import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/modules/core/authentication/authentication-service.service';
import { SessionService } from 'src/app/services/shared/session/session.service';
import { getTokenExpirationState } from 'src/app/services/shared/token/token.utils';

export const adminV2AuthGuard: CanActivateFn = async (route, state) => {
    const authService = inject(AuthenticationService);
    const sessionService = inject(SessionService);
    const router = inject(Router);

    const userSession = authService.getUserSession();

    if (!userSession?.token) {
        router.navigate(['/login']);
        return false;
    }

    const tokenState = getTokenExpirationState(userSession.token);

    if (tokenState === 'valid') {
        return true;
    }

    // Token is expired — show dialog and wait for resolution
    const result = sessionService.checkSession();

    if (result === 'valid') {
        return true;
    }

    return await result;
};
